import axios from 'axios';
import {
  BASE_URL,
  API_ENDPOINTS,
  getFurnitureByIdEndpoint,
  FURNITURE_PAGE,
  FURNITURE_LIMIT,
  FEEDBACK_PAGE,
  FEEDBACK_LIMIT,
} from './constants.js';

axios.defaults.baseURL = BASE_URL;

// Functions for Categories
export async function getCategories() {
  const response = await axios.get(API_ENDPOINTS.CATEGORIES);
  const categoriesData = response.data;
  return categoriesData;
}

// Functions for Furnitures
export async function getFurnitures(currentPage = FURNITURE_PAGE) {
  const { data } = await axios(
    `${API_ENDPOINTS.FURNITURES}?page=${currentPage}&limit=${FURNITURE_LIMIT}`
  );
  return data;
}

// Furniture by Categories
export async function getFurnituresByCategories(categoryId, currentPage) {
  const { data } = await axios(
    `${API_ENDPOINTS.FURNITURES}?page=${currentPage}&limit=${FURNITURE_LIMIT}&category=${categoryId}`
  );
  return data;
}

// Popular Furnitures
export async function getPopularFurnitures(currentPage = FURNITURE_PAGE) {
  const { data } = await axios(
    `${API_ENDPOINTS.FURNITURES}?page=${currentPage}&limit=${FURNITURE_LIMIT}&type=popular`
  );
  return data;
}

// Furniture by Id
export async function getFurnitureByID(id) {
  const endpoint = getFurnitureByIdEndpoint(id);
  const response = await axios.get(endpoint);
  const furnitureItem = response.data;
  return furnitureItem;
}

// Feedbacks
export async function getFeedbacks(
  params = { page: FEEDBACK_PAGE, limit: FEEDBACK_LIMIT }
) {
  const response = await axios.get(API_ENDPOINTS.FEEDBACKS, { params });
  const feedbackData = response.data;
  return feedbackData;
}

// Orders
export async function createOrder(orderData) {
  const response = await axios.post(API_ENDPOINTS.ORDERS, orderData);
  const createOrder = response.data;
  return createOrder;
}
